import { SvgIcon } from '@mui/material';
import { TextButtonStyles } from './styles';
import { TextButtonProps } from './types';

export const TextButton = ({
  disabled,
  handleClick,
  text,
  size,
  $outline,
  fullWidth,
  width,
  marginTop,
  startIcon,
  id,
  textColor,
  'data-testid': dataTestId,
}: TextButtonProps) => {
  return (
    <TextButtonStyles
      data-testid={dataTestId}
      id={id}
      textColor={textColor}
      width={width}
      fullWidth={fullWidth}
      startIcon={startIcon && <SvgIcon component={startIcon} />}
      $outline={$outline}
      size={size}
      marginTop={marginTop}
      disabled={disabled}
      onClick={() => handleClick?.()}
    >
      {text}
    </TextButtonStyles>
  );
};
